import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

import { petrol } from '../../../styles/mui/colors';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.JSX.Element}
 */
const IconAmenitiesPoolComponent = ({ color = petrol.main, ...rest }) => {
  return (
    <SvgIcon sx={{ color }} {...rest}>
      <svg
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Pool ladder */}
        <path d="M8 4.5a2 2 0 0 0-2 2V17" />
        <path d="M18 4.5a2 2 0 0 0-2 2V17" />
        <path d="M6 8.5h10" />
        <path d="M6 12.5h10" />
        {/* Water surface */}
        <path d="M2 19.5c1.667-1.5 3.333-1.5 5 0s3.333 1.5 5 0 3.333-1.5 5 0 3.333 1.5 5 0" />
      </svg>
    </SvgIcon>
  );
};

IconAmenitiesPoolComponent.displayName = 'IconAmenitiesPool';

const IconAmenitiesPool = React.memo(IconAmenitiesPoolComponent);

export default IconAmenitiesPool;
